import { STATUS } from "@/constants/statuses";
import BaseStore from "@/stateManagement/BaseStore";
import { StoreConfig } from "@datorama/akita";
import { singleton } from "tsyringe";

import { CAN_LEAVE_REVIEW_MESSAGE_KEY } from "../constants/index";

export type CanLeaveReviewState = {
    canLeaveReview: boolean;
    canLeaveReviewMessageKey:
        | (typeof CAN_LEAVE_REVIEW_MESSAGE_KEY)[keyof typeof CAN_LEAVE_REVIEW_MESSAGE_KEY]
        | null;
    canLeaveReviewStatus: STATUS;
};

function createInitialState(): CanLeaveReviewState {
    return {
        canLeaveReview: false,
        canLeaveReviewMessageKey: null,
        canLeaveReviewStatus: STATUS.VIRGIN,
    };
}

@singleton()
@StoreConfig({ name: "CanLeaveReviewStore", resettable: true })
class CanLeaveReviewStore extends BaseStore<CanLeaveReviewState> {
    constructor() {
        super(createInitialState());
    }

    setCanLeaveReviewStatus(status: STATUS) {
        this.update((state) => ({
            ...state,
            canLeaveReviewStatus: status,
        }));
    }
}

export default CanLeaveReviewStore;
